import { css as t } from "../stitches.config.es.js";
const n = t({
  display: "flex",
  gap: "5px",
  fontSize: "$medium",
  alignItems: "center"
}), i = t({
  display: "block",
  overflowX: "hidden",
  textOverflow: "ellipsis"
}), e = t({
  variants: {
    tbd: {
      true: {
        color: "$csGray500"
      }
    }
  }
}), s = t({
  fontSize: "$medium",
  variants: {
    link: {
      true: {
        "&:link": {
          color: "$csHiContrast",
          textDecoration: "none"
        },
        "&:visited": {
          color: "$csHiContrast",
          textDecoration: "none"
        },
        "&:hover": {
          textDecoration: "none",
          cursor: "pointer"
        },
        [`&:hover .${e}`]: {
          textDecoration: "underline"
        }
      }
    }
  }
}), r = t({
  color: "$csDarkGrey",
  fontSize: "$small"
}), l = t({
  "@media print": {
    display: "none"
  }
}), c = t({
  verticalAlign: "bottom"
});
t({
  margin: "2.5px 0"
});
export {
  c as expandIconStyles,
  l as iconStyles,
  r as infoStyles,
  i as nameInfoStyles,
  s as nameStyles,
  n as styles,
  e as textStyles
};
//# sourceMappingURL=Player.styles.es.js.map
